import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import queryString from "query-string";
import styles from "../../gmanewstyle.module.css"; // ⬅️ use shared GMA style file
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import logoimage from "../assets/Group -2.png";

export default function ChangePasswordPage() {
  const navigate = useNavigate();
  const { userProfileId, token } = queryString.parse(useLocation().search);

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirm] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  useEffect(() => {
    document.title = "GMA Portal || Change Password";
    if (!token || !userProfileId) {
      setError(
        "Missing token or profile ID. Please start from your profile page."
      );
    }
  }, [token, userProfileId]);

  const validatePassword = (pw) => pw.length >= 10;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!validatePassword(password)) {
      return setError("Password must be at least 10 characters.");
    }
    if (password !== confirmPassword) {
      return setError("Passwords do not match.");
    }

    try {
      const res = await fetch(
        `https://portal.gmacc.co.za/api/user-profile/update/${userProfileId}/`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ cj_password: password }),
        }
      );
      const data = await res.json();

      if (res.ok) {
        setSuccess("Password changed! Redirecting to login…");
        setTimeout(() => navigate("/"), 2000);
      } else {
        setError(data.error || "Failed to change password.");
      }
    } catch {
      setError("Server error. Please try again.");
    }
  };

  return (
    <div className={styles.page}>
      {/* 50/50 layout: left photo, right form – matches statement download page */}
      <div className={styles.authFrame}>
        <div className={styles.authMedia} aria-hidden="true"></div>

        <div className={styles.authPanel}>
          <div className={styles.formContainer}>
            <img
              src={logoimage}
              alt="Gauteng Management Agents"
              className={styles.logoImage}
            />
            <h1 className={styles.heading}>Change Password</h1>
            <p className={styles.subhead}>
              Enter and confirm your new password for your GMA portal profile.
            </p>

            {error && <p className={styles.errorText}>{error}</p>}
            {success && <p className={styles.successText}>{success}</p>}

            <form onSubmit={handleSubmit}>
              {/* New Password */}
              <div className={styles.inputShell}>
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="New Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className={styles.input}
                />
                <button
                  type="button"
                  className={styles.passwordToggle}
                  onClick={() => setShowPassword((v) => !v)}
                >
                  <svg viewBox="0 0 24 24">
                    <path d="M12 5c-5 0-9 4.5-9 7s4 7 9 7 9-4.5 9-7-4-7-9-7zm0 11a4 4 0 110-8 4 4 0 010 8zm0-6a2 2 0 100 4 2 2 0 000-4z" />
                  </svg>
                </button>
              </div>

              {/* Confirm Password */}
              <div className={styles.inputShell}>
                <input
                  type={showConfirm ? "text" : "password"}
                  placeholder="Confirm Password"
                  value={confirmPassword}
                  onChange={(e) => setConfirm(e.target.value)}
                  required
                  className={styles.input}
                />
                <button
                  type="button"
                  className={styles.passwordToggle}
                  onClick={() => setShowConfirm((v) => !v)}
                >
                  <svg viewBox="0 0 24 24">
                    <path d="M12 5c-5 0-9 4.5-9 7s4 7 9 7 9-4.5 9-7-4-7-9-7zm0 11a4 4 0 110-8 4 4 0 010 8zm0-6a2 2 0 100 4 2 2 0 000-4z" />
                  </svg>
                </button>
              </div>

              <button type="submit" className={styles.portalButton}>
                Change Password
              </button>
            </form>

            <div className={styles.backLink} onClick={() => navigate(-1)}>
              Back
            </div>
            <div className={styles.backLink} onClick={() => navigate("/#/")}>
              Log Out
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
